<template>
        <div>

            <div>
                <div class="container">
                    <div class="container-title">协议商品信息</div>
                    <e-search
                            :data="filterInfo.data"
                            :field-list="filterInfo.fieldList"
                            :list-type-info="listTypeInfo"
                            :width="filterInfo.width"
                            @handleFilter="handleFilter"
                            @handleReset="handleReset"
                    ></e-search>
                </div>
                <div class="container">
                    <TableList
                            ref="tables"
                            :loading="loading1"
                            :table-data="tableData1"
                            :table-label="tableLabel1"
                            :selection-show="true"
                            :row-key="rowKey1"
                            @handleButton="handleButton1"
                            @handleSortChange="handleSortChange1"
                            @handleSelectionChange="handleSelectionChange1"
                    >
                        <template v-slot:image="slot">
                            <div style="display: flex;justify-content: center">
                                <img :src="slot.scope.row.defaultImage" style="width: 48px;height: 48px; border:1px solid #D9D9D9" />
                            </div>
                        </template>
                        <template v-slot:rate="slot">
                            {{slot.scope.row.price ? (slot.scope.row.agreementPrice ? formatRate(slot.scope.row) : '') : '-'}}
                        </template>
                        <template v-slot:status="slot">
                            {{formatStatus(slot.scope.row.confirmStatus)}}
                        </template>
                        <template v-slot:operateSign="slot">
                            {{formatOperateSign(slot.scope.row.operateSign)}}
                        </template>
                        <template v-slot:skuName="slot">
                            <div class="table-product-name">
                                {{slot.scope.row.skuName}}
                            </div>

                        </template>
                        <template v-slot:operation="slot">
                            <el-button @click="handleSingleConfirm(slot.scope.row)" type="text" v-if="slot.scope.row.confirmStatus == 1">确认</el-button>
                            <el-button @click="handleStart(slot.scope.row)" type="text" v-if="slot.scope.row.confirmStatus == 4">启用</el-button>
                            <el-button @click="handleStop(slot.scope.row)" type="text" v-if="slot.scope.row.confirmStatus == 2">停用</el-button>
                        </template>
                    </TableList>
                    <div class="pagination">
                        <el-pagination
                                prev-text="上一页"
                                next-text="下一页"
                                @size-change="handleSizeChange1"
                                @current-change="handleCurrentChange1"
                                :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
                                layout="total, sizes, prev, pager, next, jumper"
                                :current-page="productTagPage1.currentPage"
                                :page-size="productTagPage1.pageSize"
                                :total="productTagPage1.pageTotal"
                        >
                        </el-pagination>
                    </div>

                </div>


            </div>

            <div style="margin-top: 10px" class="flex-c">
                <eui-btn type="secondary" @click="handleCancel">取消</eui-btn>
                <eui-btn type="primary" @click="handleConfirmProduct">确认</eui-btn>
            </div>

            <ConfirmDialog v-if="confirmDialogShow" :supplierCompanyId="supplierCompanyId"  :agreementId="agreementId" :selectedData="selectedData" :visible="confirmDialogShow" @close="closeConfirmDialog" @refresh="refreshList"></ConfirmDialog>
        </div>

</template>

<script>
    import TableList from '../../components/common/e-table-list'
    import Api from '../../api/agreement/index'
    import ConfirmDialog from '../../components/agreement/agreementManage/confirmDialog'
    import EuiBtn from "epec-ui/src/package/eui-btn/index";
    import eSearch from '@/modules/projectA/components/common/e-search.vue';
    export default {
        name: "agreementConfirm",
        components: {
          EuiBtn,
            TableList,
            ConfirmDialog,
          eSearch
        },
        props: {
        },
        data() {
            return {
              filterInfo: {
                data: {
                  skuName:null,
                  confirmStatus:null,
                },
                fieldList: [
                  {label: '商品名称', type: 'input', value: 'skuName',},
                  {label: '协议价状态', type: 'select', value: 'confirmStatus',list:'confirmStatusList'},
                ]
              },
              listTypeInfo:{
                confirmStatusList:[
                  {id: 1, name: '待确认',},
                  {id: 2, name: '已确认',},
                  {id: 3, name: '拒绝',},
                  {id: 4, name: '停用',},
                ]
              },
                agreementDetail:'',
                loading:false,
                tableData:[],
                tableLabel: [
                    { label: '企业名称', param: 'companyName', align: 'center',slot:'companyName'},
                ],
                // productTagPage: {
                //     currentPage: 1,
                //     pageSize: 10,
                //     pageTotal: 0,
                // },
                loading1:false,
                tableData1:[
                ],
                tableLabel1: [
                    { label: '图片', param: 'defaultImage', align: 'center',width:'80', slot:'image'},
                    { label: '商品名称', param: 'skuName', align: 'center',width:'200',slot:'skuName' },
                    { label: '商品编号', param: 'skuCode', align: 'center',width:'200' },
                    { label: '计量单位', param: 'unitValue', align: 'center', },
                    { label: '协议价（元）', param: 'agreementPrice', align: 'center',width:'200'},
                    { label: '市场价（元）', param: 'price', align: 'center',width:'200'},
                    { label: '优惠比例', param: 'rate', align: 'center',width:'200',slot:'rate'},
                    { label: '变更内容', param: 'operateSign', align: 'center',width:'200',slot:'operateSign'},
                    { label: '协议价状态', param: 'status', align: 'center',width:'200',slot:'status'},
                    { label: '操作', align: 'center',width:'200',slot:'operation'},
                ],
                productTagPage1: {
                    currentPage: 1,
                    pageSize: 10,
                    pageTotal: 0,
                },
                agreementConfirm:1,
                indexShow:true,
                selectedData:[],
                rowKey:'companyId',
                rowKey1: 'skuCode',
                confirmDialogShow: false,
                agreementId:'',
                loading2:false,
                tableData2:[],
                tableLabel2: [
                    { label: '物料类别', param: 'categoryName', align: 'center',slot:'categoryName'},
                ],
                productTagPage2:{
                    currentPage: 1,
                    pageSize: 10,
                    pageTotal:0
                },
                query:{
                    skuName:'',
                    confirmStatus:''
                },
                supplierCompanyId:'',
                rules:{
                    agreementCode:[{required:true,trigger:'blur',message:'协议编号不能为空'}],
                    agreementName:[{required:true,trigger:'blur',message:'协议名称不能为空'}],
                    firstParty:[{required:true,trigger:'blur',message:'甲方公司不能为空'}],
                    supplierCompanyName:[{required:true,trigger:'blur',message:'供应商不能为空'}],
                    startDate:[{required:true,trigger:'blur',message:'开始日期不能为空'}],
                    endDate:[{required:true,trigger:'blur',message:'开始日期不能为空'}]
                },
                tableData3:[],
                quickNavActive:0
            }
        },
        computed: {},
        created() {
            this.getAgreementDetail();
        },
        methods: {
          getAgreementDetail(){
            this.agreementId = this.$route.query.agreementId;
            Api.getAgreementDetail({agreementId: this.agreementId}).then((res) => {
              if (res.success) {
                this.agreementDetail = res.data;
                this.supplierCompanyId = this.agreementDetail.supplierCompanyId
                this.tableData = this.agreementDetail.agreementMembers
                this.getProductPriceList()
                this.getMdmTypeList()
              }
            });
          },
            handleButton(){
            },
            handleSortChange(){},
            handleSelectionChange(){},
            handleButton1(){
            },
            handleSortChange1(){},
            handleSelectionChange1(val){
                this.selectedData = val
            },
            handleSizeChange1(val){
                this.productTagPage1.pageSize = val
                this.productTagPage1.currentPage = 1
                this.getProductPriceList()
            },
            handleCurrentChange1(val){
                this.productTagPage1.currentPage = val
                this.getProductPriceList()
            },
            formatRate(val){
                return ((((val.price - val.agreementPrice) / val.price) * 100).toFixed(2)) + '%'
            },
            formatStatus(val){
                let res = ''
                switch (val) {
                    case 0: res='未提交';break;
                    case 1: res='待确认';break;
                    case 2: res='已确认';break;
                    case 3: res='拒绝'; break;
                    case 4: res='停用'; break;
                }
                return res;
            },
            formatOperateSign(val){
                let res = '' ;
                switch (val) {
                    case 0: res='新增'; break;
                    case 1: res='调价'; break;
                    case 2: res='删除'; break;
                }
                return res
            },
            getProductPriceList(){
                let params = {
                    agreementId: this.agreementDetail.agreementId,
                    pageSize:this.productTagPage1.pageSize,
                    pageNum: this.productTagPage1.currentPage,
                    skuName:this.query.skuName,
                    confirmStatus:this.query.confirmStatus,
                    userIdentity:'purchase'
                }
                Api.getProductPriceList(params)
                    .then((res) => {
                        if(res.data){
                            this.tableData1 = res.data.records
                            this.productTagPage1.pageTotal = res.data.total
                        }
                    })
            },
            handleConfirm(){

            },
            handleCancel(){
                 this.goToUrl()
            },
            goToUrl () {
                this.$store.state.tagsList.map((item, index) => {
                    if (item.path == this.$route.path) {
                        this.$store.state.tagsList.splice(index, 1);
                    }
                })
                this.$router.go(-1);
            },
            handleConfirmProduct(){
                if(this.selectedData.length == 0){
                    this.$message({
                        type:'success',
                        message:'请至少选择一条数据'
                    })
                }else {
                    this.confirmDialogShow = true
                }
            },
            handleClose(){
                this.$router.push({path:'/agreementManage'})
            },
            closeConfirmDialog(){
                this.confirmDialogShow = false
            },
            refreshList(){
                this.getProductPriceList()
                this.selectedData.length = 0
                this.$refs.tables.$refs.table.clearSelection()
            },
            handleSizeChange(val){
                this.productTagPage2.pageSize = val
                this.productTagPage2.currentPage = 1
                this.getMdmTypeList()
            },
            handleCurrentChange(val){
                this.productTagPage2.currentPage = val
                this.getMdmTypeList()
            },
            getMdmTypeList(){
                let params = {
                    agreementId:this.agreementId,
                }

                Api.getMdmTypeList(params)
                    .then((res) => {
                        if(res.data){
                            for(let i=0;i<res.data.length;i++){
                                if((i+1) % 2 == 0){
                                    this.$set(res.data[i],'index', i+1)
                                    this.tableData2.push(res.data[i])
                                }else {
                                    this.$set(res.data[i],'index', i+1)
                                    this.tableData3.push(res.data[i])
                                }
                            }

                        }
                    })
            },
          handleFilter(val){
            this.query.skuName = val.skuName;
            this.query.confirmStatus = val.confirmStatus;
            this.productTagPage1.currentPage = 1;
            this.getProductPriceList()
          },
          handleReset(){
            this.query.skuName = '';
            this.query.confirmStatus = '';
            this.productTagPage1.currentPage = 1;
            this.getProductPriceList()
          },
            handleSearch(){
                this.getProductPriceList()
            },
            handleSingleConfirm(val){
                this.selectedData.length = 0
                this.selectedData.push(val)
                this.confirmDialogShow = true
            },
            handleStart(val){
                let params = {
                    agreementId:this.agreementDetail.agreementId,
                    skuId:val.skuId,
                    supplierCompanyId:this.agreementDetail.supplierCompanyId
                }
                Api.startAgreementPrice(params)
                    .then((res) => {
                        if(res.code == '200'){
                            this.$message({
                                type:'success',
                                message:'成功启用'
                            })
                            this.refreshList()
                        }
                    })
            },
            handleStop(val){
                let params = {
                    agreementId:this.agreementDetail.agreementId,
                    skuId:val.skuId,
                    supplierCompanyId:this.agreementDetail.supplierCompanyId
                }
                Api.stopAgreementPrice(params)
                    .then((res) => {
                        if(res.code == '200'){
                            this.$message({
                                type:'success',
                                message:'成功停用'
                            })
                            this.refreshList()
                        }
                    })
            },
            handleDownload(val){
                window.open(val);
            },
        }

    }
</script>

<style lang="scss" scoped>
    .agreement-content{
        display:flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        .container-title{
            font-size: 16px;
            color: #333;
            margin-bottom: 20px;
            width: 100%;
        }
        .container-body{
            width: 100%;
            .el-input-width{
                width: 266px;
                height: 28px;
            }
            .container-purchase{
                background: #F8F8F8;
                width: 725px;
                height: 424px;
                padding: 20px;
                display: flex;
                flex-direction: column;
                .left{
                    width: 308px;
                    height: 360px;
                    background-color: #FFFFFF;
                    padding: 10px 10px 10px;
                    .search{
                        width: 100%;
                        .scrollbar{
                            height: 242px;
                            overflow: hidden;
                        }
                    }
                }
                .right{
                    width: 298px;
                    height: 360px;
                    background-color: #FFFFFF;
                    padding: 10px 10px 10px;
                    .scrollbar{
                        height: 316px;
                        overflow: hidden;
                        .scrollbar-li{
                            display: flex;
                            justify-content: space-between;
                            cursor: pointer
                        }
                        .scrollbar-active{
                            background: #F4F7FF;
                        }
                    }
                }
                .middle{
                    width: 60px;
                    height: 360px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    img{
                        height: 35px;
                        width: 18px;
                    }
                }
                .tip{
                    font-size: 14px;
                    color: #999999;
                }
            }
            .tabs-area{
                margin-bottom: 20px;
                .scrollbar{
                    height: 290px;
                    overflow: hidden;
                    .table{
                        display: flex;
                        flex-direction: row;
                    }
                }
            }
        }
        .agreement-container{
            background: #fff;
            margin-bottom: 10px;
            box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px 20px;


        }
    }

    .scrollbar ::v-deep .el-scrollbar__wrap{
        overflow: hidden;
        margin-right: 0 !important;
    }
    .scrollbar ::v-deep .el-scrollbar__bar.is-vertical{
        background: #F5F5F5;
        border-radius: 2px;
        width: 3px;
        opacity: 1;
        margin-right: -2px;
    }
    .scrollbar ::v-deep .el-scrollbar__bar.is-horizontal{
        background: #F5F5F5;
        border-radius: 2px;
        height: 3px;
        margin-bottom: -2px;
        &:hover{
            opacity: 0;
        }
    }
    .tabs-area ::v-deep .el-tabs__header{
        margin: 0 0 0 !important;
    }
    .tabs-area ::v-deep .el-tabs__header .el-tabs__nav{
        border-radius: 0 !important;
    }
    .table ::v-deep .el-table__empty-block{
        min-height: 0 !important;
    }
    .table ::v-deep .el-table__empty-text{
        display: none;
    }
    ::v-deep {
        .el-rate__icon {
            font-size: 20px;
            margin-right: 2px;
        }

        .tabs-area {

            .el-tabs__nav {
                border-radius: 0;
            }

            .el-tabs__header {
                margin-bottom: 0;
            }

            .el-tabs__nav .el-tabs__item {
                width: 176px;
                text-align: center;
                font-size: 14px;
                line-height: 40px;
                height: 40px;

                &.is-active {
                    background: #F4F7FF;
                    color: #0064C8;
                }

                &.is-active::after {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    content: '';
                    width: 100%;
                    height: 2px;
                    background: #0064C8;
                }
            }
            .el-tabs__content{
                border-left:1px solid #ebeef5;
                border-right:1px solid #ebeef5;
                border-bottom:1px solid #ebeef5;
            }
        }
    }
</style>
